var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "container-fluid" },
    [
      _c("BarreFiltres", {
        attrs: { filtres: _vm.filtres },
        on: {
          "appliquer-filtre": function($event) {
            return _vm.appliquerFiltre($event)
          }
        }
      }),
      _c("div", { staticClass: "flex-center-center" }, [
        _c(
          "div",
          { staticClass: "card col-12 col-xl-10 col-xxl-8 height-responsive" },
          [
            _c("div", { staticClass: "card-header" }, [
              _vm._v(" Menus - Documentation ")
            ]),
            _c(
              "div",
              {
                staticClass:
                  "card-container height-responsive-body height-responsive-1b"
              },
              [
                _vm._m(0),
                _vm._m(1),
                _vm._m(2),
                _vm._m(3),
                _vm._m(4),
                _vm._m(5),
                _vm._m(6),
                _c("section", { attrs: { id: "sectionIngredients" } }, [
                  _c("div", { staticClass: "header header-tertiary" }, [
                    _vm._v("Ingrédients")
                  ]),
                  _c("div", { staticClass: "card-body" }, [
                    _vm._m(7),
                    _c("p", [
                      _vm._v(
                        "Cette section de la recette vous permet de gérer les ingrédients qui composent votre recette et vous permet de préciser les grammages pour les ingrédients à la pièce."
                      )
                    ]),
                    _c("p", [
                      _vm._v(
                        "Le champ de recherche permet de selectionner des ingrédients à ajouter à la recette. Vous avez également la possibilité de choisir une sous-recette."
                      )
                    ]),
                    _c("p", [
                      _vm._v(
                        'Ex: Avec des andouillettes, si vous souhaitez ajouter une sauce, effectuez une recherche (par exemple, "sauce moutarde"). Une fois sélectionnée, en survolant le nom de la recette, vous pourrez obtenir un aperçu de son contenu'
                      )
                    ]),
                    _vm._m(8),
                    _vm._m(9),
                    _vm._m(10),
                    _c("p", [
                      _vm._v(
                        "Les éléments qui composent chaque ligne ingrédient, de gauche à droite :"
                      )
                    ]),
                    _vm._m(11),
                    _c("div", { staticClass: "container mb-3" }, [
                      _c(
                        "table",
                        { staticClass: "table table-bordered text-center" },
                        [
                          _vm._m(12),
                          _c("tbody", [
                            _c("tr", { staticClass: "top:10px" }, [
                              _c(
                                "td",
                                [
                                  _c("ToggleButton", {
                                    attrs: {
                                      labels: {
                                        checked: "Commander",
                                        unchecked: "Ne pas commander"
                                      },
                                      color: {
                                        checked: "#025DBF",
                                        unchecked: "#CCCCCC"
                                      },
                                      height: 25,
                                      width: 150
                                    }
                                  })
                                ],
                                1
                              ),
                              _vm._m(13)
                            ]),
                            _vm._m(14),
                            _vm._m(15),
                            _vm._m(16)
                          ])
                        ]
                      )
                    ])
                  ])
                ]),
                _vm._m(17),
                _vm._m(18),
                _vm._m(19),
                _vm._m(20)
              ]
            )
          ]
        )
      ])
    ],
    1
  )
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c(
      "section",
      { staticClass: "docSection", attrs: { id: "sectionSuivi" } },
      [
        _c("div", { staticClass: "card-body" }, [
          _c("p", [
            _vm._v(
              'Après avoir cliqué sur l\'option "Menus", vous serez automatiquement redirigé vers la fonctionnalité de "Suivi".'
            )
          ]),
          _c("p", [
            _vm._v(
              "Les menus dans Mercudyn sont basés sur des structures sur lesquelles vous définissez vos services et composantes."
            )
          ]),
          _c("div", { staticClass: "h6 important" }, [
            _c("p", [
              _vm._v(
                "Une structure de menu définit un convive type, le ou les services, les composantes ainsi que les effectifs théoriques. "
              )
            ]),
            _c("p", [
              _vm._v(
                "Un menu est définit pour une période et contient des recettes ainsi que des effectifs."
              )
            ])
          ])
        ])
      ]
    )
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c(
      "section",
      { staticClass: "docSection", attrs: { id: "creationStucture" } },
      [
        _c("div", { staticClass: "header header-tertiary" }, [
          _vm._v("Créer une structure de menu")
        ]),
        _c("div", { staticClass: "card-body" }, [
          _c("p", [
            _vm._v(
              "Une structure de menu permet de donner un cadre, un patron à vos menus."
            )
          ]),
          _c("p", [
            _vm._v(
              'Pour créer une structure de menu, cliquez sur le bouton "créer une stucture de menu"'
            )
          ]),
          _c("p", [_vm._v("Sélectionner le type de votre structure")]),
          _c("div", { staticClass: "flex-center-center mb-3" }, [
            _c("div", { staticClass: "col-6" }, [
              _c("img", {
                staticClass: "border-black border-rounded w-100",
                attrs: {
                  src: require("../../assets/images/documentation/menus/suivi/structure.png"),
                  alt: "Illustration type de structure"
                }
              })
            ])
          ]),
          _c("p", [_vm._v("Pour la création d'une nouvelle structure :")]),
          _c("div", { staticClass: "container mb-3" }, [
            _c("img", {
              staticClass: "border-black border-rounded w-100",
              attrs: {
                src: require("../../assets/images/documentation/menus/suivi/nouvelleStructure.png"),
                alt: "Illustration nouvelle structure"
              }
            })
          ]),
          _c("p", [
            _vm._v(
              "Nommez votre structure et sélectionnez le convive type rattaché* puis définissez le type de gestion. soit par composantes soit par stucture"
            )
          ]),
          _c("ul", { staticClass: "puces" }, [
            _c("li", [
              _vm._v(
                "Gestion par Structure : choisissez un régime alimentaire ainsi qu'une texture qui seront utilisés pour l'ensemble de la structure."
              )
            ]),
            _c("li", [
              _vm._v(
                "Gestion par Composantes : Chaque composante peut être dupliquée et déclinée pour différents régimes alimentaires et textures."
              )
            ])
          ]),
          _c("p", [
            _vm._v(
              "Pour chaque service vous pouvez définir les composantes souhaitées ainsi que les effectifs théoriques."
            )
          ]),
          _c("div", { staticClass: "container mb-3" }, [
            _c("img", {
              staticClass: "border-black border-rounded w-100",
              attrs: {
                src: require("../../assets/images/documentation/menus/suivi/structureComposantes.png"),
                alt: "Illustration nouvelle structure"
              }
            })
          ]),
          _c("p", [
            _vm._v(
              "L'exemple ci-dessus montre une duplication de l'entrée principale, au déjeuner avec un effectif de 12 convives diabétiques."
            )
          ]),
          _c("p", [
            _vm._v(
              "Lorsque vous avez terminé de créer votre structure, vous pouvez l'enregistrer via le bouton en bas de la fenêtre."
            )
          ]),
          _c("div", { staticClass: "h6 important" }, [
            _c("p", [
              _c("strong", [_vm._v("Sécurités autour des structures de menu")])
            ]),
            _c("p", [
              _vm._v(
                "La modification d'une structure ne peux pas impacter et ne modifiera pas une semaine comportant un menu, même vide (sans recette)."
              )
            ]),
            _c("p", [
              _vm._v(
                "Cela permet de conserver les menus passés tout en permettant de faire évoluer la structure (ajout de composante, de service...)."
              )
            ])
          ]),
          _c("div", { staticClass: "note" }, [
            _c("p", [
              _vm._v(
                "*Une structure dite Neutre peut être créée sans convive rattaché. Cela permet une gestion globale d'un menu par duplication utilisée par certains de nos adhérents."
              ),
              _c("br"),
              _vm._v(
                " N'hésitez pas à vous rapprocher de votre Conseiller.ère de Gestion pour plus d'informations. "
              )
            ])
          ])
        ])
      ]
    )
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c(
      "section",
      { staticClass: "docSection", attrs: { id: "creationStuctureAgap" } },
      [
        _c("div", { staticClass: "header header-tertiary" }, [
          _vm._v("Créer une structure de menu - Copie d'une structure Agap'pro")
        ]),
        _c("div", { staticClass: "card-body" }, [
          _c("p", [
            _vm._v("Vous avez la possibilité de copier une structure Agap pro.")
          ]),
          _c("div", { staticClass: "flex-center-center mb-3" }, [
            _c("div", { staticClass: "col-6" }, [
              _c("img", {
                staticClass: "border-black border-rounded w-100",
                attrs: {
                  src: require("../../assets/images/documentation/menus/suivi/structureCopieAgap.png"),
                  alt:
                    "Illustration de création de structure de menu copie Agap pro"
                }
              })
            ])
          ]),
          _c("p", [_vm._v("Cela vous permet d'importer les menus Agap'pro.")])
        ])
      ]
    )
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c(
      "section",
      { staticClass: "docSection", attrs: { id: "creationMenu" } },
      [
        _c("div", { staticClass: "header header-tertiary" }, [
          _vm._v("Créer un menu")
        ]),
        _c("div", { staticClass: "card-body" }, [
          _c("div", { staticClass: "h6 important" }, [
            _c("p", [_c("strong", [_vm._v("Info")])]),
            _c("p", [
              _vm._v(
                "Lorsque vous validez la création d'une structure, Mercudyn vous propose de créer une semaine de menu sur la période en cours."
              )
            ])
          ]),
          _c("p", [
            _vm._v(
              "Pour créer un menu, sélectionnez la structure concernée dans la liste, choisissez la période de consommation puis cliquez sur le bouton de création de menu. Vous retrouvez votre structure de menu vide, sur la période sélectionnée et prête à accueillir vos recettes !"
            )
          ]),
          _c("p", [
            _vm._v(
              "Si vous employez une structure Agap'pro, vous avez la possibilité d'importer les menus préparés par notre équipe de diététiciens."
            )
          ]),
          _c("p", [
            _vm._v(
              "Dans l'exemple ci-dessous, nous avons pour le lundi une journée contenant des recettes et le mardi le menu vide, prêt à recevoir des recettes."
            )
          ]),
          _c("div", { staticClass: "flex-center-center mb-3" }, [
            _c("div", { staticClass: "col-6" }, [
              _c("img", {
                staticClass: "border-black border-rounded w-100",
                attrs: {
                  src: require("../../assets/images/documentation/menus/suivi/menuDetails.png"),
                  alt: "Illustration d'un menu avec des recettes"
                }
              })
            ])
          ]),
          _c("p", [_vm._v("Sur votre menu vous pouvez :")]),
          _c("ul", { staticClass: "puces" }, [
            _c("li", [
              _vm._v(
                "Ajouter des recettes, les remplacer, modifier les effectifs (voir tableau ci-dessous)."
              )
            ]),
            _c("li", [
              _c("a", { attrs: { href: "#duplicationMenu" } }, [
                _vm._v("Dupliquer le menu")
              ]),
              _vm._v(
                " vers une autre structure (qui ne doit pas comporter de menu sur la période souhaitée)."
              )
            ]),
            _c("li", [
              _vm._v(
                "Exporter le menu (l'export utilise les titres publiques des recettes)."
              )
            ]),
            _c("li", [
              _vm._v(
                "Supprimer le menu de la structure (permet l'édition de la structure sur cette période ou de recevoir une duplication depuis une autre structure)."
              )
            ])
          ]),
          _c("p", [
            _vm._v(
              "L'ajustement des effectifs peut se faire à plusieurs endroits dans MercuDyn 5."
            )
          ]),
          _c("p", [
            _vm._v(
              "Pour chaque composante vous pouvez définir l'effectif théorique (à commander et produire) ainsi que sur les jours passés, renseigner l'effectif réel pour calculer la perte produite."
            )
          ]),
          _c("div", { staticClass: "container mb-3" }, [
            _c("table", { staticClass: "table table-bordered text-center" }, [
              _c("thead", { staticClass: "table-header" }, [
                _c("tr", [
                  _c("th", [_vm._v("Boutons")]),
                  _c("th", { staticClass: "aligner-gauche" }, [
                    _vm._v("Signification")
                  ])
                ])
              ]),
              _c("tbody", [
                _c("tr", [
                  _c("td", [
                    _c("button", { staticClass: "btn btn-primary" }, [
                      _c("i", {
                        staticClass: "fas fa-users cursor-pointer has-tooltip"
                      })
                    ])
                  ]),
                  _c("td", { staticClass: "aligner-gauche" }, [
                    _vm._v(
                      "Permet de modifier l'effectif de la journée ou du service en impactant les composantes de la catégorie"
                    )
                  ])
                ]),
                _c("tr", [
                  _c("td", [
                    _c(
                      "button",
                      {
                        staticClass: "btn btn-primary has-tooltip",
                        staticStyle: { "border-radius": "8px" },
                        attrs: { type: "button" }
                      },
                      [_c("i", { staticClass: "fas fa-plus" })]
                    )
                  ]),
                  _c("td", { staticClass: "aligner-gauche" }, [
                    _vm._v(
                      "Permet de sélectionner une recette à ajouter au menu"
                    )
                  ])
                ]),
                _c("tr", [
                  _c("td", [
                    _c(
                      "button",
                      {
                        staticClass: "btn btn-primary",
                        attrs: { type: "button" }
                      },
                      [_c("i", { staticClass: "fas fa-exchange-alt" })]
                    )
                  ]),
                  _c("td", { staticClass: "aligner-gauche" }, [
                    _vm._v("Permet de changer la recette de la composante")
                  ])
                ]),
                _c("tr", [
                  _c("td", [
                    _c(
                      "button",
                      {
                        staticClass: "btn btn-danger has-tooltip",
                        staticStyle: { "border-radius": "8px" },
                        attrs: { type: "button" }
                      },
                      [_c("i", { staticClass: "fas fa-times" })]
                    )
                  ]),
                  _c("td", { staticClass: "aligner-gauche" }, [
                    _vm._v("Permet d'enlever la recette de la composante")
                  ])
                ])
              ]),
              _c("thead", { staticClass: "table-header" }, [
                _c("tr", [
                  _c("th", [_vm._v("Icônes")]),
                  _c("th", { staticClass: "aligner-gauche" }, [
                    _vm._v("Signification")
                  ])
                ])
              ]),
              _c("tbody", [
                _c("tr", [
                  _c("td", [
                    _c("i", {
                      staticClass:
                        "fas fa-exclamation-triangle text-warning has-tooltip v-tooltip-open"
                    })
                  ]),
                  _c("td", { staticClass: "aligner-gauche" }, [
                    _vm._v(
                      "Permet de signaler qu'une recette n'a pas été consultée"
                    )
                  ])
                ])
              ]),
              _c("thead", { staticClass: "table-header" }, [
                _c("tr", [
                  _c("th", [_vm._v("Légende")]),
                  _c("th", { staticClass: "aligner-gauche" }, [
                    _vm._v("Signification")
                  ])
                ])
              ]),
              _c("tbody", [
                _c("tr", [
                  _c("td", [
                    _c(
                      "p",
                      {
                        staticStyle: { color: "orange", "font-weight": "600" }
                      },
                      [_vm._v(" Cake aux fruits ")]
                    )
                  ]),
                  _c("td", { staticClass: "aligner-gauche" }, [
                    _vm._v(
                      "Si la police d'une recette est orange, cela indique qu'il y a un ingrédient manquant dans la recette."
                    )
                  ])
                ])
              ])
            ])
          ]),
          _c("p", [
            _vm._v(
              "Lorsque vous survolez le nom de la recette, une fenêtre s'ouvre, affichant diverses informations telles que le nom de la recette, le prix par personne, les ingrédients et leur quantité."
            )
          ]),
          _c("div", { staticClass: "flex-center-center mb-3" }, [
            _c("div", { staticClass: "col-6" }, [
              _c("img", {
                staticClass: "border-black border-rounded w-100",
                attrs: {
                  src: require("../../assets/images/documentation/menus/suivi/fenetrePopup.png"),
                  alt: "Illustration fenêtre au survol"
                }
              })
            ])
          ]),
          _c("p", [
            _vm._v(
              "Si vous cliquez sur le nom de la recette, cela vous amène directement à l'onglet des recettes."
            )
          ]),
          _c("div", { staticClass: "h6 important" }, [
            _c("p", [
              _vm._v(
                "Pensez à enregistrer vos modifications via le bouton **ENREGISTRER** en haut de la page."
              )
            ])
          ])
        ])
      ]
    )
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c(
      "section",
      { staticClass: "docSection", attrs: { id: "duplicationMenu" } },
      [
        _c("div", { staticClass: "header header-tertiary" }, [
          _vm._v("Dupliquer un menu")
        ]),
        _c("div", { staticClass: "card-body" }, [
          _c("p", [
            _vm._v(
              "Vous avez la possibilité de dupliquer un menu vers un autre établissement. Pour cela, selectionnez le bouton : "
            ),
            _c(
              "button",
              { staticClass: "btn btn-primary", attrs: { type: "button" } },
              [_vm._v("Dupliquer le menu")]
            )
          ]),
          _c("p", [
            _vm._v("Une fenêtre s'ouvre avec plusieurs champs à compléter.")
          ]),
          _c("p", [
            _vm._v(
              "Une fois le menu d'origine renseigné, vous avez la possibilité de dupliquer votre menu sur un ou plusieurs établissements. L'établissement de destination doit déjà contenir une structure de menu pour effectuer une duplication."
            )
          ]),
          _c("p", [
            _vm._v(
              'Si vous souhaitez également dupliquer le menu avec des recettes modifiées, vous devez cochez "Prendre en compte les modifications de recettes".'
            )
          ]),
          _c("p", [
            _vm._v(
              "Si un menu est déjà existant, pour l'établissement de destination, vous avez la possibilité d'écraser les données en cochant la case \"Ecraser le(s) menu(s) de destination présent(s)\""
            )
          ]),
          _c("div", { staticClass: "flex-center-center mb-3" }, [
            _c("div", { staticClass: "col-6" }, [
              _c("img", {
                staticClass: "border-black border-rounded w-100",
                attrs: {
                  src: require("../../assets/images/documentation/menus/recettes/duplicationMenu.png"),
                  alt: "Illustration d'une duplication de menu"
                }
              })
            ])
          ])
        ])
      ]
    )
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c(
      "section",
      { staticClass: "docSection", attrs: { id: "sectionRecettes" } },
      [
        _c("div", { staticClass: "header header-tertiary" }, [
          _vm._v("Recettes")
        ]),
        _c("div", { staticClass: "card-body" }, [
          _c("p", [
            _vm._v(
              "L'écran de gestion des recettes permet une visualisation rapide de l'ensemble de vos recettes ainsi que celles créées par l'équipe de cuisiniers et diététiciennes d'Agap'pro."
            ),
            _c("br"),
            _vm._v(
              " Des fonctions de filtres et de prévisualisation offrent un classement et un affichage rapide des informations importantes. "
            )
          ]),
          _c("div", { staticClass: "container mb-3" }, [
            _c("img", {
              staticClass: "border-black border-rounded w-100",
              attrs: {
                src: require("../../assets/images/documentation/menus/recettes/recetteGestion.png"),
                alt: "Image gestion des recettes"
              }
            })
          ]),
          _c("p", [
            _vm._v(
              "1. Filtre par catégories. Filtre la liste des recettes suivant les catégories sélectionnées pour les retrouver facilement."
            )
          ]),
          _c("p", [
            _vm._v(
              "2. Filtre par composantes. Filtre la liste des recettes suivant les composantes sélectionnées dans celles-ci. Sert de filtre lors de l'ajout de recette dans un menu."
            )
          ]),
          _c("p", [_vm._v("3. Filtre des recettes par appartenance.")]),
          _c("div", { staticClass: "container mb-3" }, [
            _c("table", { staticClass: "table table-bordered text-center" }, [
              _c("thead", { staticClass: "table-header" }, [
                _c("tr", [
                  _c("th", [_vm._v("Boutons")]),
                  _c("th", { staticClass: "aligner-gauche" }, [
                    _vm._v("Signification")
                  ])
                ])
              ]),
              _c("tbody", [
                _c("tr", [
                  _c("td", [
                    _c("img", {
                      attrs: {
                        src: require("../../assets/images/documentation/menus/recettes/recette-filtre-1utilisateur.png"),
                        alt: "Bouton Mes recettes"
                      }
                    })
                  ]),
                  _c("td", { staticClass: "aligner-gauche" }, [
                    _vm._v(
                      "Mes recettes, visible uniquement par mon profil. (Suppression autorisée)"
                    )
                  ])
                ]),
                _c("tr", [
                  _c("td", [
                    _c("img", {
                      attrs: {
                        src: require("../../assets/images/documentation/menus/recettes/recette-filtre-2etablissement.png"),
                        alt: "Bouton Recettes de mon établissement"
                      }
                    })
                  ]),
                  _c("td", { staticClass: "aligner-gauche" }, [
                    _vm._v(
                      "Les recettes disponibles sur mon établissement et mes collègues. (Pas de suppression par sécurité)"
                    )
                  ])
                ]),
                _c("tr", [
                  _c("td", [
                    _c("img", {
                      attrs: {
                        src: require("../../assets/images/documentation/menus/recettes/recette-filtre-3universelles.png"),
                        alt: "Bouton Recettes universelles"
                      }
                    })
                  ]),
                  _c("td", { staticClass: "aligner-gauche" }, [
                    _vm._v(
                      "Les recettes universelles Agap'pro. (Dupliquation uniquement)"
                    )
                  ])
                ]),
                _c("tr", [
                  _c("td", [
                    _c("img", {
                      attrs: {
                        src: require("../../assets/images/documentation/menus/recettes/recette-filtre-4toutes.png"),
                        alt: "Bouton Toutes les recettes"
                      }
                    })
                  ]),
                  _c("td", { staticClass: "aligner-gauche" }, [
                    _vm._v("Toutes les recettes de toutes les catégories.")
                  ])
                ])
              ])
            ])
          ]),
          _c("p", [
            _vm._v(
              "4. Recherche dans la liste des recettes. La recherche est effectuée en tenant compte des différents filtres appliqués."
            )
          ]),
          _c("p", [
            _vm._v(
              "5. Liste des recettes. Le premier clic sur une recette affiche point n°7, tandis que le deuxième clic permet d'éditer la recette."
            )
          ]),
          _c("p", [_vm._v("6. Actions sur la recette.")]),
          _c("div", { staticClass: "container mb-3" }, [
            _c("table", { staticClass: "table table-bordered text-center" }, [
              _c("thead", { staticClass: "table-header" }, [
                _c("tr", [
                  _c("th", [_vm._v("Boutons")]),
                  _c("th", { staticClass: "aligner-gauche" }, [
                    _vm._v("Signification")
                  ])
                ])
              ]),
              _c("tbody", [
                _c("tr", [
                  _c("td", [
                    _c(
                      "button",
                      {
                        staticClass: "btn btn btn-success btn-secondary",
                        attrs: { alt: "Nouvelle", type: "button" }
                      },
                      [_vm._v("Nouvelle")]
                    )
                  ]),
                  _c("td", { staticClass: "aligner-gauche" }, [
                    _vm._v("Créer une nouvelle recette.")
                  ])
                ]),
                _c("tr", [
                  _c("td", [
                    _c(
                      "button",
                      {
                        staticClass: "btn btn btn-success btn-secondary",
                        attrs: { type: "button" }
                      },
                      [_vm._v("Dupliquer")]
                    )
                  ]),
                  _c("td", { staticClass: "aligner-gauche" }, [
                    _vm._v("Dupliquer la recette sélectionnée.")
                  ])
                ]),
                _c("tr", [
                  _c("td", [
                    _c(
                      "button",
                      {
                        staticClass: "btn btn btn-danger btn-secondary",
                        attrs: { type: "button" }
                      },
                      [_vm._v("Supprimer")]
                    )
                  ]),
                  _c("td", { staticClass: "aligner-gauche" }, [
                    _vm._v("Supprimer la recette sélectionnée.")
                  ])
                ])
              ])
            ])
          ]),
          _c("p", [_vm._v("7. Aperçu de la recette au clic dans la liste.")])
        ])
      ]
    )
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("section", { attrs: { id: "sectionRecettesEdition" } }, [
      _c("div", { staticClass: "header header-tertiary" }, [
        _vm._v("Création / Edition de recette")
      ]),
      _c("div", { staticClass: "card-body" }, [
        _c("p", [
          _vm._v(
            "Que se soit pour la création ou l'édition, l'écran reste très similaire."
          )
        ]),
        _c("div", { staticClass: "h6 important" }, [
          _c("p", [
            _vm._v(
              "Les recettes Agap'pro sont proposées à l'ensemble de nos adhérents. "
            )
          ]),
          _c("p", [
            _vm._v(
              "Nos recettes initiales (hors sauces) sont calculées pour 100 portions. Les grammages sont établis pour des enfants en primaire. "
            )
          ]),
          _c("p", [
            _vm._v("Vous trouverez en bas de cette page"),
            _c("a", { attrs: { href: "#sectionExemples" } }, [
              _vm._v(" des exemples")
            ]),
            _vm._v(" concrets afin de vous aider à démarrer.")
          ])
        ]),
        _c("div", { staticClass: "container mb-3" }, [
          _c("img", {
            staticClass: "border-black border-rounded w-100",
            attrs: {
              src: require("../../assets/images/documentation/menus/recettesEdition/recette-edit-1general.png"),
              alt: "Image recette édition généralité"
            }
          })
        ]),
        _c("ul", { staticClass: "puces" }, [
          _c("li", [
            _c("span", { staticClass: "bold600" }, [_vm._v("Titre interne")]),
            _vm._v(", ex: Purée flocons "),
            _c("br"),
            _vm._v(
              " Titre de la recette dans le logiciel (Recettes, Menus, fiches de production...). "
            )
          ]),
          _c("li", [
            _c("span", { staticClass: "bold600" }, [_vm._v("Titre public")]),
            _vm._v(", ex: Purée du Chef"),
            _c("br"),
            _vm._v(
              " Titre de la recette affiché sur les exports à destination du public.. "
            )
          ]),
          _c("li", [
            _c("span", { staticClass: "bold600" }, [_vm._v("Pour")]),
            _vm._v(" et "),
            _c("span", { staticClass: "bold600" }, [
              _vm._v("Unité de production")
            ]),
            _vm._v(" "),
            _c("br"),
            _vm._v(
              " Pour combien de l'unité choisie la recette est-elle réalisée."
            ),
            _c("br"),
            _vm._v(" Ex: Pour 100 personnes ; Pour 3 L ; Pour 5 KG... ")
          ]),
          _c("li", [
            _c("span", { staticClass: "bold600" }, [_vm._v("Type de convive")]),
            _vm._v(", ex: Sco Primaire "),
            _c("br"),
            _vm._v(" Sur quel convive la recette est-elle basée. "),
            _c("br"),
            _vm._v(
              " Ce champ n'apparait que si Personne est sélectionné en Unité de recette. "
            )
          ]),
          _c("li", [
            _c("span", { staticClass: "bold600" }, [_vm._v("Catégorie")]),
            _vm._v(", ex: Dessert fruit cru "),
            _c("br"),
            _vm._v(
              " Dans quelle catégorie classer la recette pour les filtres. "
            )
          ]),
          _c("li", [
            _c("span", { staticClass: "bold600" }, [
              _vm._v("Zone de préparation")
            ]),
            _vm._v(", ex: Chaud, Froid..."),
            _c("br"),
            _vm._v(
              " Vous pouvez choisir la zone de préparation de votre choix "
            )
          ])
        ])
      ])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "container mb-3" }, [
      _c("img", {
        staticClass: "border-black border-rounded w-100",
        attrs: {
          src: require("../../assets/images/documentation/menus/recettesEdition/recette-edit-2ingredient.png"),
          alt: "Image recette édition ingrédients"
        }
      })
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("p", [
      _vm._v("Si celle-ci n'a pas été consulté, un point d'exclamation:"),
      _c("i", {
        staticClass: "fas fa-exclamation-triangle text-warning has-tooltip"
      }),
      _vm._v(
        " sera visible. Vous pouvez la visualiser et la modifier en cliquant dessus."
      )
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "flex-center-center mb-3" }, [
      _c("div", { staticClass: "col-6" }, [
        _c("img", {
          staticClass: "border-black border-rounded w-100",
          attrs: {
            src: require("../../assets/images/documentation/menus/recettesEdition/rechercheSousRecette.png"),
            alt: "Image recette"
          }
        })
      ])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "h6 important" }, [
      _c("p", [
        _vm._v(
          "Les ingrédients sont associés aux produits de la mercuriale ainsi qu'à vos produits en gré à gré. "
        )
      ]),
      _c("p", [
        _vm._v(
          "Un ingrédient peut être lié à des produits de différentes familles (ex: Haricot vert fin va être proposé en Surgelés et en Epicerie)."
        )
      ])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("ul", { staticClass: "puces" }, [
      _c("li", [
        _vm._v(
          " Famille produit de l'ingrédient. Si plusieurs existent, peut-être changée à la volée. "
        )
      ]),
      _c("li", [_vm._v(" Le nom de l'ingrédient. ")]),
      _c("li", [
        _vm._v(" La quantité "),
        _c("span", { staticClass: "bold600" }, [_vm._v(" brut ")]),
        _vm._v(" nécessaire selon l'unité de production. ")
      ]),
      _c("li", [
        _c("span", { staticClass: "bold600" }, [
          _vm._v(" L'Unité de Production ")
        ]),
        _vm._v(" peut être en PCE, KG et L. "),
        _c("br"),
        _vm._v(
          " Si l'unité est en PCE des précisions par convive peuvent être indiquées. "
        )
      ]),
      _c("li", [
        _vm._v(" Le convive type pour l'ingrédient à la pièce. "),
        _c("br"),
        _vm._v(
          " Permet en dupliquant l'ingrédient de préciser une quantité différente de l'ingrédient selon le convive sélectionné. "
        ),
        _c("br"),
        _vm._v(
          " Si aucun convive type supplémentaire n'est définit, la quantité du convive type de la recette sera sélectionné. "
        )
      ]),
      _c("li", [
        _vm._v(
          " Si l'ingrédient est à la fois à la pièce et en portion, le logiciel peut proposer de sélectionner un grammage spécifique par convive type (cf. figure ci-dessous). "
        )
      ]),
      _c("div", { staticClass: "container mb-3" }, [
        _c("img", {
          staticClass: "border-black border-rounded w-100",
          attrs: {
            src: require("../../assets/images/documentation/menus/recettesEdition/recette-edit-3pcegramme.png"),
            alt: "Image d'ingrédient à la pièce et en portion"
          }
        })
      ]),
      _c("li", [
        _vm._v(
          " Un ingrédient noté en orange n'a pas de produit rattaché ex: F&L de saison lorsque non référencés "
        )
      ])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("thead", { staticClass: "table-header" }, [
      _c("tr", [
        _c("th", [_vm._v("Boutons")]),
        _c("th", { staticClass: "aligner-gauche" }, [_vm._v("Signification")])
      ])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("td", { staticClass: "aligner-gauche" }, [
      _vm._v("Commander: Le produit de cette ligne va être commandé."),
      _c("br"),
      _vm._v(
        "Ne pas commander: Le produit de cette ligne ne sera pas commandé, mais il sera quand même pris en compte dans le prix de la recette."
      )
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("tr", [
      _c("td", [
        _c(
          "button",
          { staticClass: "btn btn-primary", attrs: { type: "button" } },
          [_c("i", { staticClass: "fas fa-copy" })]
        )
      ]),
      _c("td", { staticClass: "aligner-gauche" }, [
        _vm._v("Permet la duplication de l'ingrédient (uniquement PCE).")
      ])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("tr", [
      _c("td", [
        _c(
          "button",
          { staticClass: "btn btn-primary", attrs: { type: "button" } },
          [_c("i", { staticClass: "fas fa-star" })]
        )
      ]),
      _c("td", { staticClass: "aligner-gauche" }, [
        _vm._v(
          "Visualisation de la liste des produits. Permet d'ajouter des favoris pour cette recette et d'accéder aux fiches techniques."
        )
      ])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("tr", [
      _c("td", [
        _c(
          "button",
          {
            staticClass: "btn btn-danger",
            attrs: { type: "button", "aria-label": "Supprimer cet ingrédient" }
          },
          [
            _c("span", { attrs: { "aria-hidden": "true" } }, [
              _c("i", { staticClass: "fas fa-trash" })
            ])
          ]
        )
      ]),
      _c("td", { staticClass: "aligner-gauche" }, [
        _vm._v(
          "Le produit de cette ligne sera supprimé, son prix ne sera pas inclus dans le calcul de la recette."
        )
      ])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("section", { attrs: { id: "sectionParAssiette" } }, [
      _c("div", { staticClass: "header header-tertiary" }, [
        _vm._v("Quantités par assiette")
      ]),
      _c("div", { staticClass: "card-body" }, [
        _c("div", { staticClass: "container mb-3" }, [
          _c("img", {
            staticClass: "border-black border-rounded w-100",
            attrs: {
              src: require("../../assets/images/documentation/menus/recettesEdition/recette-edit-4qteassiette.png"),
              alt: "Image des quantités par assiette"
            }
          })
        ]),
        _c("p", [
          _vm._v(
            "Cette zone permet de définir pour chaque convive type la portion par service. "
          )
        ]),
        _c("p", [_vm._v("La valeur de référence est encadrée en vert")])
      ])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("section", [
      _c("div", { staticClass: "header header-tertiary" }, [
        _vm._v("Marche à suivre")
      ]),
      _c("div", { staticClass: "card-body" }, [
        _c("p", [
          _vm._v(
            "Texte libre pour détailler le déroulement de la recette ou autres précisions à apporter (ex: Utiliser le programme 4 sur le four 1)."
          )
        ])
      ])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("section", { attrs: { id: "sectionCompatibilites" } }, [
      _c("div", { staticClass: "header header-tertiary" }, [
        _vm._v("Compatibilités")
      ]),
      _c("div", { staticClass: "card-body" }, [
        _c("p", [
          _vm._v(
            "Cette zone permet de définir comment la recette doit être gérée par Mercudyn que ce soit en classement, calculs ou propositions."
          )
        ]),
        _c("ul", { staticClass: "puces" }, [
          _c("li", [
            _c("span", { staticClass: "bold600" }, [
              _vm._v("Textures incompatibles")
            ]),
            _vm._v(" et "),
            _c("span", { staticClass: "bold600" }, [
              _vm._v("Régimes alimentaires")
            ]),
            _vm._v(
              " incompatibles permettent de définir les compatibilités avec les convives définis dans les structures de menus. "
            )
          ]),
          _c("li", [
            _c("span", { staticClass: "bold600" }, [
              _vm._v(" Composantes de repas")
            ]),
            _vm._v(
              " permet d'indiquer dans quelles composantes du menu la recette doit être proposée par défaut. "
            )
          ]),
          _c("li", [
            _c("span", { staticClass: "bold600" }, [
              _vm._v("Catégories GEMRCN")
            ]),
            _vm._v(
              " permet d'indiquer la ou les catégories compatibles du GEMRCN. "
            )
          ])
        ])
      ])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("section", { attrs: { id: "sectionExemples" } }, [
      _c("div", { staticClass: "header header-tertiary" }, [
        _vm._v("Exemples: Création / Edition de recette")
      ]),
      _c("div", { staticClass: "card-body" }, [
        _c("h6", [_vm._v("Exemple 1, les vinaigrettes, sauces et fonds")]),
        _c("p", [
          _vm._v('J\'ai une recette "Vinaigrette balsamique", au litre.')
        ]),
        _c("p", [
          _vm._v(
            'J\'insère ma recette "Vinaigrette balsamique" en tant que sous recette dans mes recettes "Salade de laitue balsamique", "Salade de betteraves balsamique" [...] dans toutes mes recettes où je souhaite ajouter une sauce vinaigrette balsamique.'
          )
        ]),
        _c("p", [
          _vm._v(
            "Ma recette de \"Vinaigrette balsamique\" n'existant qu'une seule fois est étant simplement utilisée dans mes autres recettes, si un jour je souhaite modifier ma vinaigrette je n'ai qu'à modifier ma recette de \"Vinaigrette balsamique\" et chaque recette où ma vinaigrette est utilisée en profitera directement, sans avoir à passer sur chaque recette utilisant ma vinaigrette."
          )
        ])
      ]),
      _c("div", { staticClass: "card-body" }, [
        _c("h6", [_vm._v("Exemple 2, les produits à la pièce")]),
        _c("p", [_vm._v("Prenons l'exemple du steak haché")]),
        _c("p", [
          _vm._v(
            "Si sur mon établissement je prépare mes steaks pour trois convives type, Mercudyn vous permet de gérer tous vos cas en une seule recette."
          )
        ]),
        _c("p", [
          _vm._v(
            "En dupliquant la ligne de produit à la pièce, je peux paramétrer pour chaque convive type mes quantités."
          )
        ]),
        _c("div", { staticClass: "container mb-3" }, [
          _c("img", {
            staticClass: "border-black border-rounded w-100",
            attrs: {
              src: require("../../assets/images/documentation/menus/recettesEdition/exemple2.png"),
              alt: "Image recette édition généralité"
            }
          })
        ]),
        _c("p", [
          _vm._v(
            "Dans cet exemple de recette de steak haché, j'ai trois fois ma ligne de steak."
          )
        ]),
        _c("p", [
          _vm._v(
            'La première est "ma base", pour mes 100 convives en Sco Primaire, comme définit en haut de ma recette.'
          )
        ]),
        _c("p", [
          _vm._v(
            "La deuxième dit que si je sers des Sco Maternelles, je donne 1/2 steak de 100g par convive."
          )
        ]),
        _c("p", [
          _vm._v(
            "La troisième dit que si je sers des Personnes Agées en Institution, je donne 1 steak de 80g par personne."
          )
        ]),
        _c("p", [
          _vm._v(
            "Si je sers un convive type non géré par la duplication de ma ligne, comme par exemple Entreprise Adulte, c'est la ligne de base qui servira de référence. Ici, 1 steak de 100g par convive."
          )
        ])
      ])
    ])
  }
]
render._withStripped = true

export { render, staticRenderFns }